var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Tags = createReactClass({
    mixins: [PureRenderMixin],

    render: function () {
        var tagNodes = this.props.tagIDs ? this.props.tagIDs.map(function(tagID){
            var name = '';

            var len = this.props.tags.length;
            for(var i = 0; i < len; i++){
                if(this.props.tags[i]._id === tagID){
                    name = this.props.tags[i].name;
                    break;
                }
            }

            return <span key={tagID}>{name}</span>;
        }.bind(this)) : [];

        return (
            tagNodes.length > 0 ? <p className="tags clearfix">{tagNodes}</p> : null
        );
    }
});

module.exports = Tags;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/tags.jsx